/*
 * @Author: tfq
 * @Date: 2025-09-23 10:38:22
 * @LastEditTime: 2026-01-21 13:50:42
 * @Description: 
 */
import request from "@/util/request.js";
//货品详情
export const getProductDetail = (params) =>
  request({
    url: "/wms/wx/officialAccount/productSnDetail",
    method: "GET",
    params,
  });

//货品详情
export const getProductDetailBySkuSn = (params) =>
  request({
    url: "/wms/wx/officialAccount/productDetailBySkuSn",
    method: "GET",
    params,
  });

// 签名
export const getJsSdk = () =>
  request({
    url: `/wms/wx/officialAccount/jssdk/config?url=${encodeURIComponent(
      window.location.href.split("#")[0]
    )}`,
    // url: `/wms/wx/officialAccount/jssdk/config?url=${encodeURIComponent('http://m.goldmatrix.cn/p/016040003000')}`,
    method: "GET",
  });

// 能否开通见赏
export const canRent = (params) =>
  request({
    url: `/rent/platform/products/getProductService`,
    method: "GET",
    params,
  });
